import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(<App />, document.getElementById('root'));

// Register the service worker (production only).
// Updates will be detected in the background; when a new version is ready,
// your serviceWorkerRegistration.js will trigger SKIP_WAITING + reload.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Optional: keep this for logging/analytics or to show a toast later.
    console.log('A new version is available. Activating updated service worker...', registration);
  },
  onSuccess: (registration) => {
    console.log('Service worker registered successfully.', registration);
  },
});
